module.exports = __webpack_public_path__ + "img/21_30.434ba7b5.png";